import { render, staticRenderFns } from "./FormsCopyCode.vue?vue&type=template&id=70ef80b2&scoped=true"
import script from "./FormsCopyCode.vue?vue&type=script&lang=js"
export * from "./FormsCopyCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ef80b2",
  null
  
)

export default component.exports